import { createFormAction } from "redux-form-saga";
export const FORM_KEY = "CONTACT_FORM";
export const ContactFormAction = createFormAction(FORM_KEY);
